import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useSelector } from "react-redux";
import {
  AddSlideCall,
  AddSubTitlesCall,
  AddTitlesCall,
  DeleteSubTitlesCall,
  DeleteTitlesCall,
  EditSubTitlesCall,
  EditTitlesCall,
  GetTitlesCall,
  SwapTitlesCall,
} from "../../redux/api/title.api";
import Icon from "@mui/material/Icon";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import MDSnackbar from "components/MDSnackbar";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useDispatch } from "react-redux";
import { setLang } from "../../redux/slices/generalSlice";

function Titles({ type }) {
  const slideType = type;
  // const type = "his";
  const initialItems = useSelector((state) => state?.title?.titles);
  const lang = useSelector((state) => state.general?.lang);
  const redux = useSelector((state) => state);
  console.log("pippo redux", redux);

  const [items, setItems] = useState(initialItems);
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [message, setMessage] = useState("");
  // const [lang, setLanguage] = useState("en");

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const fetchTitles = async () => {
    await GetTitlesCall(lang, type);
  };

  useEffect(() => {
    fetchTitles();
  }, [type, lang]);

  useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  const handleAddTitle = () => {
    AddTitlesCall({
      title: `New Title ${items?.length + 1}`,
      body: `Description ${items?.length + 1}`,
      lang,
      type,
    });
  };

  const handleAddSubtitle = (itemId) => {
    AddSubTitlesCall({
      title: `New Subtitle ${items?.length + 1}`,
      body: `Description ${items?.length + 1}`,
      title_id: itemId,
      lang,
      type,
    });
  };

  const handleEdit = (id, newValue, type) => {
    if (type === "MainTitle" || type === "MainBody") {
      const body = {
        id,
        lang,
        type: slideType,
        [type === "MainTitle" ? "title" : "body"]: newValue,
      };
      EditTitlesCall(body);
    } else {
      const body = {
        id,
        lang,
        type: slideType,
        [type === "SubTitle" ? "title" : "body"]: newValue,
      };
      EditSubTitlesCall(body);
    }
  };

  const handleDeleteSubTitle = async (id) => {
    const body = {
      id,
      lang,
      type,
    };
    const confirmation = window.confirm(
      "Are you sure you want to delete this subtitle? All your pins, texts and slide inside this subtitle will be deleted permanently."
    );
    if (confirmation) {
      const res = DeleteSubTitlesCall(body);
      if (res?.status === 400) {
        setMessage(res?.message);
        setTimeout(() => {
          openErrorSB();
        }, 200);
      } else {
        setMessage("The subtitle deleted successfully!");
        setTimeout(() => {
          openSuccessSB();
        }, 200);
      }
    }
  };
  const handleDeleteTitle = async (id) => {
    const body = {
      id,
      lang,
      type,
    };
    const confirmation = window.confirm(
      "Are you sure you want to delete this title and all its subtitles? All your pins, texts and slide inside this subtitle will be deleted permanently."
    );
    if (confirmation) {
      const res = await DeleteTitlesCall(body);
      if (res?.status === 400) {
        setMessage(res?.message);
        setTimeout(() => {
          openErrorSB();
        }, 200);
      } else {
        setMessage("The title deleted successfully!");
        setTimeout(() => {
          openSuccessSB();
        }, 200);
      }
    }
  };

  const handleAddMaterial = async (id) => {
    const res = await AddSlideCall({ title_id: id, lang, type });
    console.log("pippo res", res);

    navigate(`/showTitle/${res?.slide?.id}/${lang}`);
  };

  const handleLanguageChange = (event) => {
    // setLanguage(event.target.value);
    dispatch(setLang(event.target.value));
  };

  const renderItem = (item, index) => {
    const filteredTitle = item?.titleLocalizations?.filter((e) => e.field == "title");
    const filteredBody = item?.titleLocalizations?.filter((e) => e.field == "body");

    const title = filteredTitle?.[0]?.value || "Click to edit the title";
    const body = filteredBody?.[0]?.value || "Click to edit the body";
    const url = require("../../assets/images/no-image.jpg");
    return (
      <MDBox
        mb={3}
        p={2}
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        border="1px solid #ccc"
        borderRadius="8px"
      >
        <div
          style={{
            alignContent: "flex-start",
            justifyContent: "flex-start",
            width: "100%",
            display: "flex",
          }}
        >
          {index !== 0 && (
            <ArrowDropUpIcon
              fontSize="large"
              onClick={() => {
                const body = {
                  current_id: item?.id,
                  goal_id: items?.[index - 1]?.id,
                  lang,
                  type,
                };
                SwapTitlesCall(body);
              }}
            />
          )}

          {items?.length !== index + 1 && (
            <ArrowDropDownIcon
              fontSize="large"
              onClick={() => {
                const body = {
                  current_id: item?.id,
                  goal_id: items?.[index + 1]?.id,
                  lang,
                  type,
                };
                SwapTitlesCall(body);
              }}
            />
          )}
        </div>

        <EditableTitle
          title={title}
          titleFont={"title"}
          onEdit={(newTitle) => handleEdit(item.id, newTitle, "MainTitle")}
        />

        <EditableTitle title={body} onEdit={(body) => handleEdit(item.id, body, "MainBody")} />
        <div
          style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: 20 }}
        >
          {/* Add Subtitle Button on the Left */}
          <MDButton color="info" variant="contained" onClick={() => handleAddSubtitle(item.id)}>
            + Add Subtitle
          </MDButton>

          {/* Delete Button on the Right */}
          <MDButton color="error" variant="contained" onClick={() => handleDeleteTitle(item.id)}>
            Delete
          </MDButton>
        </div>

        {item?.subtitles?.length > 0 && (
          <Grid container spacing={2} mt={2}>
            {item.subtitles.map((subtitle, idx) => {
              const label = isEmpty(subtitle?.slides) ? "Add Material" : "Edit Material";

              const filteredTitle = subtitle?.titleLocalizations?.filter((e) => e.field == "title");
              const filteredBody = subtitle?.titleLocalizations?.filter((e) => e.field == "body");

              const title = filteredTitle?.[0]?.value || "Click to edit the sub title";
              const body = filteredBody?.[0]?.value || "Click to edit the sub body";
              return (
                <Grid item xs={12} sm={6} md={4} key={subtitle.id}>
                  <MDBox
                    p={2}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    borderRadius="8px"
                    style={{ backgroundColor: "white" }}
                  >
                    <img
                      src={
                        isEmpty(subtitle?.slides?.[0]?.Files?.[0]?.url)
                          ? url
                          : subtitle?.slides?.[0]?.Files?.[0]?.url + "/3/3/3.png"
                      }
                      alt={title}
                      style={{
                        width: !isEmpty(subtitle?.slides?.[0]?.Files?.[0]?.url) ? "100%" : "50%",
                        height: "auto",
                        borderRadius: "8px",
                        marginBottom: "10px",
                      }}
                    />

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <EditableTitle
                        title={title}
                        titleFont={"title"}
                        onEdit={(newTitle) => handleEdit(subtitle.id, newTitle, "SubTitle")}
                      />
                      <EditableTitle
                        title={body}
                        onEdit={(newBody) => handleEdit(subtitle.id, newBody, "SubBody")}
                      />
                      <div
                        style={{
                          alignContent: "flex-start",
                          justifyContent: "space-between",
                          width: "100%",
                          display: "flex",
                          marginTop: 20,
                          marginBottom: 10,
                        }}
                      >
                        {idx !== 0 && (
                          <ArrowLeftIcon
                            fontSize="large"
                            onClick={() => {
                              const body = {
                                current_id: subtitle?.id,
                                goal_id: item?.subtitles?.[idx - 1]?.id,
                                lang,
                                type,
                              };
                              SwapTitlesCall(body);
                            }}
                          />
                        )}

                        {item?.subtitles?.length !== idx + 1 && (
                          <ArrowRightIcon
                            fontSize="large"
                            onClick={() => {
                              const body = {
                                current_id: subtitle?.id,
                                goal_id: item?.subtitles?.[idx + 1]?.id,
                                lang,
                                type,
                              };
                              SwapTitlesCall(body);
                            }}
                          />
                        )}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <MDButton
                          color="error"
                          variant="contained"
                          onClick={() => handleDeleteSubTitle(subtitle.id)}
                        >
                          Delete
                        </MDButton>
                        <MDButton
                          color="info"
                          variant="contained"
                          onClick={() => handleAddMaterial(subtitle.id)}
                        >
                          {label}
                        </MDButton>
                        {/* <div>
                          <input
                            type="file"
                            id="fileInput"
                            style={{ display: "none" }}
                            onChange={handleFileUpload}
                          />
                          <button
                            onClick={() => document.getElementById("fileInput").click()}
                            style={{
                              marginTop: "10px",
                              backgroundColor: "#2196F3",
                              color: "white",
                              padding: "10px",
                              borderRadius: "4px",
                              cursor: "pointer",
                              border: "none",
                            }}
                          >
                            Upload File
                          </button>
                        </div> */}
                        <MDSnackbar
                          color="success"
                          icon="check"
                          title={message}
                          open={successSB}
                          onClose={closeSuccessSB}
                          close={closeSuccessSB}
                          bgWhite
                        />
                        <MDSnackbar
                          color="error"
                          icon="warning"
                          title={message}
                          open={errorSB}
                          onClose={closeErrorSB}
                          close={closeErrorSB}
                          bgWhite
                        />
                      </div>
                    </div>
                  </MDBox>
                </Grid>
              );
            })}
          </Grid>
        )}
      </MDBox>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1} display="flex" justifyContent="flex-end" mb={2}>
        <Grid container spacing={2} alignItems="center">
          {/* Add Title Button on the Left */}
          <Grid item>
            <MDButton color="info" variant="contained" onClick={() => handleAddTitle()}>
              + Add Title
            </MDButton>
          </Grid>

          {/* Language Dropdown on the Right */}
          <Grid
            item
            xs
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <FormControl style={{ width: 250 }}>
              <InputLabel>Language</InputLabel>
              <Select value={lang} onChange={handleLanguageChange} style={{ height: 50 }}>
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="pt">Portugal</MenuItem>
                <MenuItem value="es">Spanish</MenuItem>
                <MenuItem value="it">Italian</MenuItem>
                <MenuItem value="ge">Germany</MenuItem>
                <MenuItem value="nl">Dutch</MenuItem>
                <MenuItem value="cn">Chines</MenuItem>
                <MenuItem value="ja">Japanese</MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={1}>
        <Grid container spacing={3}>
          {!isEmpty(items) &&
            items.map((item, index) => (
              <Grid item xs={12} key={item.id}>
                {renderItem(item, index)}
              </Grid>
            ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

const EditableTitle = ({ title, onEdit, titleFont }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentTitle, setCurrentTitle] = useState(title);
  let fontSize = "1rem";
  let fontWight = 400;

  if (titleFont == "title") {
    fontSize = "1.4rem";
    fontWight = "bold";
  }
  const handleBlur = () => {
    setIsEditing(false);
    onEdit(currentTitle);
  };

  return isEditing ? (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <input
        type="text"
        value={currentTitle}
        onChange={(e) => setCurrentTitle(e.target.value)}
        onBlur={handleBlur}
        autoFocus
        style={{
          fontSize,
          fontWight,
          textAlign: "center",
          padding: "5px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          width: "80%",
          marginRight: "10px",
        }}
      />
      <MDButton
        size={"10px"}
        color="success"
        variant="contained"
        onClick={() => {
          handleBlur();
          onEdit();
        }}
      >
        <Icon fontSize="medium">check</Icon>
      </MDButton>
    </div>
  ) : (
    <MDTypography
      variant="h6"
      onClick={() => setIsEditing(true)}
      style={{ cursor: "pointer", textAlign: "center", fontSize, fontWight }}
    >
      {title}
    </MDTypography>
  );
};

export default Titles;
